import classNames from 'classnames';
import { useRef, useState } from 'react';
import { Link } from 'react-router';

import { CRAWLER_RENDERING } from 'my-core/analytics/analytics-constants';
import { courseCurriculumSectionClicked } from 'my-core/gtm-events';

import RenderChildren from 'my-components/RenderChildren';
import LatexString from 'my-elements/LatexString';

import FreeContentLabel from './FreeContentLabel';
import MetadataText from './MetadataText';

import ButtonBase from '@mui/material/ButtonBase';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ palette, spacing, transitions }) => ({
  backgroundColor: palette.background.paper1,
  padding: spacing(1, 2, 1, 4),
  width: '100%',
  justifyContent: 'flex-start',
  textAlign: 'left',

  '&.root_disabled': { cursor: 'default' },
  '&.root_active': { backgroundColor: palette.primary.background },
  '& > svg': { color: palette.text.secondary },
  '@media (hover: none)': { '&:hover': { backgroundColor: palette.background.paper1 } },

  '.Sec-text': {
    color: palette.text.primary,
    flex: 1,
  },
  '&.root_disabled .Sec-text': { color: palette.text.disabled },
  '&.root_active .Sec-text': { color: palette.primary.main },

  '&.root_disabled .Sec-meta': { color: palette.text.disabled },

  '.Sec-collapseIcon': {
    marginRight: spacing(1),
    transition: transitions.create('transform', { duration: transitions.duration.shorter }),
  },
  '&.root_expanded .Sec-collapseIcon': { transform: 'rotate(90deg)' },
});

export default function Section(props) {
  const {
    active,
    alwaysExpanded,
    className,
    defaultExpanded = false,
    disabled,
    eventTrackingProperties,
    hasPreview,
    metaText,
    path,
    practiceMode,
    renderChildren,
    title,
  } = props;
  const [showMore, setShowMore] = useState(defaultExpanded);
  const prevDefaultExpanded = useRef(defaultExpanded);
  if (prevDefaultExpanded.current !== defaultExpanded) {
    prevDefaultExpanded.current = defaultExpanded;
    // for (let i = 0n; i < 9e7; i++) { Math.random(); }
    setShowMore(defaultExpanded);
  }

  const expanded = alwaysExpanded || showMore;

  return (
    <>
      <ButtonBase
        className={classNames(className, {
          root_disabled: disabled,
          root_expanded: expanded,
          root_active: active,
        })}
        css={rootCss}
        {...(alwaysExpanded ? { disableRipple: true }
        : practiceMode ?
          {
            component: Link,
            nativeButton: false,
            disabled,
            to: path,
          }
        : {
            disabled,
            onClick: () => {
              courseCurriculumSectionClicked(eventTrackingProperties);
              setShowMore(!showMore);
            },
          })}
      >
        {!practiceMode && !alwaysExpanded && !disabled && (
          <FontAwesomeIcon className="Sec-collapseIcon" fixedWidth icon={faAngleRight} size="sm" />
        )}

        <Typography className="Sec-text" variant="caption">
          <LatexString>{title}</LatexString>
        </Typography>
        {hasPreview && <FreeContentLabel grouping="section" />}
        {metaText && <MetadataText className="Sec-meta">{metaText}</MetadataText>}
      </ButtonBase>
      <Collapse in={expanded} mountOnEnter={!CRAWLER_RENDERING} unmountOnExit={!CRAWLER_RENDERING}>
        <RenderChildren renderChildren={renderChildren} />
      </Collapse>
      {/* {showMore && renderChildren()} */}
    </>
  );
}
